import { useMemo } from 'react';
import { useColorMode } from '@chakra-ui/react';
import { useConfig } from '~/context';
import { isLink } from '~/types';

import type { Link, Menu } from '~/types';

type MenuItems = (Link | Menu)[];

function buildItems(links: Link[], menus: Menu[]): [MenuItems, MenuItems] {
  const leftLinks = links.filter(link => link.side === 'left');
  const leftMenus = menus.filter(menu => menu.side === 'left');
  const rightLinks = links.filter(link => link.side === 'right');
  const rightMenus = menus.filter(menu => menu.side === 'right');

  const left = [...leftLinks, ...leftMenus].sort((a, b) => (a.order > b.order ? 1 : -1));
  const right = [...rightLinks, ...rightMenus].sort((a, b) => (a.order > b.order ? 1 : -1));
  return [left, right];
}

export const Footer = (): JSX.Element => {
  const { web } = useConfig();
  const { colorMode, toggleColorMode } = useColorMode();
  const [left] = useMemo(() => buildItems(web.links, web.menus), [web.links, web.menus]);

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-surface-container-lowest border-t border-slate-200 dark:border-outline-variant fixed bottom-0 left-0 right-0 z-50">
      <div className="flex justify-between items-center w-full px-container-padding py-stack-md max-w-7xl mx-auto h-16">
        <div className="flex items-center gap-stack-lg">
          <span className="font-label-caps text-label-caps text-slate-400 dark:text-on-surface-variant uppercase">
            © {currentYear} RG Provider LTDA
          </span>
          <div className="flex gap-gutter">
            {left.filter(item => {
              if (isLink(item)) {
                const url = item.url.toLowerCase();
                const title = item.title.toLowerCase();
                return !url.includes('github') && !url.includes('peering') && !url.includes('db') && !url.includes('hyperglass') && !title.includes('peering') && !title.includes('db') && !title.includes('github') && !title.includes('hyperglass');
              }
              return true;
            }).map(item => {
              if (isLink(item)) {
                return (
                  <a
                    key={item.title}
                    className="text-slate-500 hover:text-primary dark:text-on-surface-variant dark:hover:text-primary font-label-caps text-label-caps transition-colors active:scale-98 flex items-center gap-1"
                    href={item.url}
                  >
                    {item.title}
                    {item.showIcon && (
                      <span className="material-symbols-outlined text-[12px]">open_in_new</span>
                    )}
                  </a>
                );
              }
              return null;
            })}
          </div>
        </div>
        <div className="flex items-center gap-stack-md">
          <span
            onClick={toggleColorMode}
            className="material-symbols-outlined text-slate-500 hover:text-primary dark:text-on-surface-variant dark:hover:text-primary cursor-pointer transition-colors"
          >
            {colorMode === 'light' ? 'dark_mode' : 'light_mode'}
          </span>
        </div>
      </div>
    </footer>
  );
};
